<template>
    <div v-if="isLeserserviceOrHigher" class="add-gp-nummer">
        <v-tooltip :left="left" :right="right" :top="top" :bottom="bottom">
            <template v-slot:activator="{ on }">
                <v-btn
                        class="ma-0 drei_60-btn "
                        text icon small
                        v-on="on"
                        @click="show"
                        :disabled="loading || processing"
                        :loading="processing"
                >
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </template>
            <div class="max-width-btn">
                Hinzufügen einer oder mehrerer GP-Nummer(n) und Auswählen eines Medienhauses (SAP Scope).
            </div>
        </v-tooltip>
        <v-dialog v-model="showDialog" persistent max-width="500px">
            <v-card>
                <v-card-title class="title">GP-Nummer hinzufügen</v-card-title>
                <v-card-text>
                    <v-form v-model="valid" v-on:submit.prevent ref="addGpNummer">
                        <v-text-field
                            :disabled="loading || processing"
                            ref="gpNummer"
                            v-model="gpNummer"
                            @keyup="searchGp"
                            label="Geschäftspartnernummer"
                            :rules="gpNummerRules"
                        ></v-text-field>
                        <SapSelect
                            @change="setSap"
                            :loading="loading || processing"
                            label="SAP Scope"
                            :sap="sap"
                        />
                    </v-form>
                    <div class="body-2" v-if="!customerSearchComplete && processing">
                        Bitte warten...
                    </div>
                    <div v-if="!noGp && customerSearchComplete">
                        <div class="body-2 mb-2">
                            Soll dieser Geschäftspartner verknüpft werden?
                        </div>
                        <div class="body-1">
                            {{ `${customer.anrede} ${customer.vorname} ${customer.nachname}` }}
                            <br v-if="gebdat.length">
                            {{ `${gebdat}` }}
                            <br v-if="customer.strasse.length || customer.hausnummer.length || customer.plz.length || customer.ort.length">
                            <br v-if="customer.strasse.length || customer.hausnummer.length">
                            {{ `${customer.strasse} ${customer.hausnummer}` }}
                            <br v-if="customer.plz.length || customer.ort.length">
                            {{ `${customer.plz} ${customer.ort}` }}
                            <br v-if="customer.email.length">
                            <br v-if="customer.email.length">
                            {{ customer.email }}
                        </div>
                    </div>
                    <div class="body-2 drei_60-red-text" v-if="noGp && customerSearchComplete">
                        Verknüpfung nicht möglich. Es wurde
                        kein Geschäftspartner mit der GP-Nummer
                        '{{ gpNummer }}' und dem
                        SAP Scope '{{ sap }}' gefunden.
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="warning"
                        outlined
                        @click="abbort"
                        :disabled="loading"
                    >Abbrechen</v-btn>
                    <v-btn
                        color="success"
                        outlined
                        @click="addGp"
                        :loading="loading || processing"
                        :disabled="loading || !valid || processing || noGp"
                    >Speichern</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex';
import SapSelect from '@/components/SapSelect.vue';
import Api from '@/api';
import Util from '@/util';

export default {
    name: 'AddGpNummer',
    props: ['ssoId', 'gpNummern', 'tooltipPosition'],
    components: {
        SapSelect,
    },
    data() {
        return {
            customer: {
                anrede: 'Herr',
                email: 'peter@pansen.com',
                gebdat: '1994-07-22',
                nachname: 'Pansen',
                ort: 'Pansenstadt',
                plz: '05584',
                strasse: 'Pannsenweg',
                hausnummer: 5,
                vorname: 'Peter',
            },
            customerSearchComplete: false,
            noGp: true,
            loading: false,
            processing: false,
            showDialog: false,
            valid: false,
            canceled: false,
            gpNummer: '',
            gpNummerRules: [
                v => (!!v) || 'Es muss eine GP-Nummer angegeben werden.',
                v => /^[0-9]{7,10}$/.test(v) || 'Die GP-Nummer muss aus 7-10 Zahlen bestehen.',
                v => (parseInt(v, 10) >= 1000000 && parseInt(v, 10) <= 9999999999)
                    || 'Die Gp-Nummer muss zwischen 1000000 und 9999999999 liegen.',
                v => this.gpNummern.indexOf(v.trim()) < 0 || 'GP-Nummer ist bereits mit Kunden verknüpft.',
            ],
            sap: '',
            searchDelay: 500,
            searchDelayTimeout: null,
        };
    },
    methods: {
        addGp() {
            this.loading = true;
            this.processing = true;
            Api.customer.linkUserToOrder(this.ssoId, this.gpNummer, this.sap, false)
                .then(() => {
                    this.success('Die GP-Nummer wurde erfolgreich hinzugefügt.');
                    this.showDialog = false;
                    this.gpNummer = '';
                    this.sap = '';
                })
                .catch(() => {
                    this.info('Wenn die neue GP-Nummer nach dem Neuladen im Hintergrund nicht in der Übersicht'
                        + ' auftaucht ist ein Fehler aufgetreten.');
                })
                .finally(() => {
                    this.processing = false;
                    this.loading = false;
                    this.$emit('reload');
                });
        },
        searchGp() {
            if (this.valid) {
                if (this.searchDelayTimeout) {
                    clearTimeout(this.searchDelayTimeout);
                }
                this.searchDelayTimeout = setTimeout(() => {
                    this.customerSearchComplete = false;
                    this.processing = true;
                    this.canceled = false;
                    Api.customer.getByGpId(this.gpNummer, this.sap)
                        .then(({ data }) => {
                            if (!this.canceled) {
                                this.noGp = false;
                                this.customer = {
                                    ...data.data,
                                };
                            }
                        }).catch(() => {
                            if (!this.canceled) {
                                this.noGp = true;
                            }
                        })
                        .finally(() => {
                            if (!this.canceled) {
                                this.processing = false;
                                this.customerSearchComplete = true;
                            }
                        });
                }, this.searchDelayTimeout);
            } else {
                this.customerSearchComplete = false;
            }
        },
        setSap(sap) {
            this.sap = sap;
            this.$refs.addGpNummer.validate();
            setTimeout(() => this.searchGp(), 0);
        },
        show() {
            this.showDialog = true;
            setTimeout(() => this.$refs.gpNummer.focus(), 0);
        },
        abbort() {
            this.showDialog = false;
            this.gpNummer = '';
            this.sap = '';
            this.canceled = true;
            this.processing = false;

            this.info('Der Vorgang wurde abgebrochen.');
        },
        ...mapMutations('snackbar', ['success', 'info', 'error']),
    },
    computed: {
        gebdat() {
            if (this.customer.gebdat.length
                && /^[1-9]{4}-[0-9]{2}-[0-9]{2}$/.test(this.customer.gebdat)
                && this.customer.gebdat !== '0000-00-00') {
                return `geboren am ${Util.timestampToGermanDate(this.customer.gebdat)}`;
            }
            return '';
        },
        left() {
            return this.tooltipPosition === 'left';
        },
        right() {
            return this.tooltipPosition === 'right';
        },
        top() {
            return this.tooltipPosition === 'top';
        },
        bottom() {
            return this.tooltipPosition === 'bottom';
        },
        ...mapGetters(['isLeserserviceOrHigher']),
    },
};

</script>
<style lang="scss" scoped></style>
